import React from 'react';
import { createPortal } from 'react-dom';
import { backdropCloseHandlers } from '../../../../utils/backdropClose';
import './Stop3DViewerModal.css';

const Stop3DViewerModal = ({ projectId, projectName, isOpen, onClose, onStopSuccess }) => {
  const handleYes = () => {
    // Close the modal immediately
    onClose();

    // Trigger the stop success callback which will stop the instance
    if (onStopSuccess) {
      onStopSuccess();
    }
  };

  const handleNo = () => {
    onClose();
  };

  if (!isOpen) return null;

  return typeof document !== 'undefined' && createPortal(
    <div className="stop-3d-viewer-modal-overlay" {...backdropCloseHandlers(handleNo)}>
      <div className="stop-3d-viewer-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="stop-3d-viewer-modal-header">
          <i className="fas fa-exclamation-triangle stop-3d-viewer-modal-warning-icon"></i>
          <h3>Stop 3D Viewer?</h3>
        </div>
        <div className="stop-3d-viewer-modal-body">
          <br/>
          <p>You will not be able to relaunch the project until the shutdown process is over.</p>
        </div>

        <div className="stop-3d-viewer-modal-footer">
          <button
            className="stop-3d-viewer-modal-btn stop-3d-viewer-modal-btn-no"
            onClick={handleNo}
          >
            No
          </button>
          <button
            className="stop-3d-viewer-modal-btn stop-3d-viewer-modal-btn-yes"
            onClick={handleYes}
          >
            Yes
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default Stop3DViewerModal;
